import { styled, Menu, MenuItem } from '@material-ui/core';
import { IconButton } from '@ds/react-components';

//This acts as a placeholder for other elements to be placed below this.
export const TopBarStaticContainer = styled('div')({
  width: '100%',
  height: '64px',
});

//The height of the fixed container and the height of the static container must be same.
export const TopBarFixedContainer = styled('div')(({ theme, sidebar }) => ({
  width: sidebar ? `calc(100% - ${theme.dimension.sideBarWidth}px)` : '100%',
  padding: '12px 40px',
  display: 'flex',
  alignItems: 'center',
  backgroundColor: theme.palette.common.white,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: sidebar
      ? theme.transitions.duration.enteringScreen
      : theme.transitions.duration.leavingScreen,
  }),
  boxShadow: '0 1px 5px 0 rgba(0, 0, 0, 0.05)',
  position: 'fixed',
  top: 0,
  left: sidebar ? theme.dimension.sideBarWidth : 0,
  justifyContent: 'space-between',
  height: '64px',
  zIndex: theme.zIndex.drawer + 1,
}));

export const FlexGrower = styled('div')({
  flexGrow: 1,
});

export const DrawerMenuOpenButton = styled(IconButton)(({ sidebar }) => ({
  display: sidebar ? 'none' : 'block',
  marginLeft: '12px',
  marginRight: '36px',
}));

export const ProfileMenuContainer = styled('div')(({ menuopen }) => ({
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  paddingRight: menuopen ? '17px' : '0px', //Fix for disappearing scroll bar
}));

export const ProfileName = styled('p')({
  fontSize: '14px',
  margin: '0 0 0 10px',
});

export const ProfileMenu = styled(Menu)(({ theme }) => ({
  color: theme.palette.common.black,
}));

export const ProfileMenuItem = styled(MenuItem)(({ theme, line }) => ({
  color: theme.palette.common.black,
  borderBottom: line ? `1px solid ${theme.palette.common.athensGray} ` : 'none',
}));
